// extracted by mini-css-extract-plugin
export default {"actionItem":"DefinitionDangerZone-module__actionItem--DEYgJ","divider":"DefinitionDangerZone-module__divider--Bo9Qr"};